// Media Tab Component
import { ImageUpload } from '../../../components/ui/image-upload';
import { Input } from '../../../components/ui/input';
import { Label } from '../../../components/ui/label';
import { Image, Video, Smartphone } from 'lucide-react';

export const MediaTab = ({ formData, setFormData }) => {
  return (
    <div className="space-y-4">
      <ImageUpload
        label="Immagine Hero (Desktop)"
        value={formData.hero_image}
        onChange={(url) => setFormData({ ...formData, hero_image: url })}
        icon={Image}
      />
      <ImageUpload
        label="Immagine Hero (Mobile)"
        value={formData.hero_image_mobile}
        onChange={(url) => setFormData({ ...formData, hero_image_mobile: url })}
        icon={Smartphone}
        description="Se presente, sostituisce l'immagine desktop su schermi mobile"
      />
      <div className="space-y-2">
        <Label className="flex items-center gap-2">
          <Video size={16} className="text-primary" />
          Video Hero (URL YouTube/Vimeo)
        </Label>
        <Input
          value={formData.hero_video}
          onChange={(e) => setFormData({ ...formData, hero_video: e.target.value })}
          placeholder="https://www.youtube.com/watch?v=..."
          className="bg-white/5 border-white/10"
        />
      </div>
    </div>
  );
};
